module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("Daily Light: Morning & Evening")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "page14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter1a#cc15",
      "id": "dd15"
    }
  }, [_c('i', [_vm._v("January 13")])])]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "amJanuary13"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORNING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0018-03-2"
    }
  }, [_c('span', [_c('i', [_vm._v("You will keep him in perfect peace, whose mind is stayed on You, because he trusts in You.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0018-04-4"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("C")]), _vm._v("ast your burden on the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", and He shall sustain you; He shall never permit the righteous to be moved. • I will trust and not be afraid; ‘For YAH, the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", is my strength and song; He also has become my salvation.’")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-05-7"
    }
  }, [_vm._v("Why are you fearful, O you of little faith? • Be anxious for nothing, but in everything by prayer and supplication, with thanksgiving, let your requests be made known to God; and the peace of God, which surpasses all understanding, will guard your hearts and minds through Christ Jesus. • In quietness and confidence shall be your strength.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-05-8"
    }
  }, [_vm._v("The work of righteousness will be peace, and the effect of righteousness, quietness and assurance forever. • Peace I leave with you, My peace I give to you; not as the world gives do I give to you. Let not your heart be troubled, neither let it be afraid. • Peace from Him who is and who was and who is to come.")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA")]), _vm._v(". 26:3; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(". 55:22; I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA")]), _vm._v(". 12:2; M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATT")]), _vm._v(". 8:26; P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIL")]), _vm._v(". 4:6–7; I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SA")]), _vm._v(". 30:15; 32:17; J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 14:27; R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EV")]), _vm._v(". 1:4")]), _vm._v(" "), _c('p', {
    staticClass: "txl1",
    attrs: {
      "id": "aeJanuary13"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VENING")])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0018-08-12"
    }
  }, [_c('span', [_c('i', [_vm._v("Do not let the sun go down on your wrath.")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0018-09-14"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("I")]), _vm._v("f your brother sins against you, go and tell him his fault between you and him alone. If he hears you, you have gained your brother. . . . “L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", how often shall my brother sin against me, and I forgive him? Up to seven times?” Jesus said to him, “I do not say to you, up to seven times, but up to seventy times seven.” • And whenever you stand praying, if you have anything against anyone, forgive him, that your Father in heaven may also forgive you your trespasses.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-10-17"
    }
  }, [_vm._v("Therefore, as the elect of God, holy and beloved, put on tender mercies, kindness, humility, meekness, longsuffering; bearing with one another, and forgiving one another, if anyone has a complaint against another; even as Christ forgave you, so you also must do. • Be kind to one another, tenderhearted, forgiving one another, just as God in Christ also forgave you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-10-18"
    }
  }, [_vm._v("The apostles said to the Lord, “Increase our faith.”")]), _vm._v(" "), _c('p', {
    staticClass: "txc1"
  }, [_vm._v("E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PH")]), _vm._v(". 4:26; M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATT")]), _vm._v(". 18:15, 21–22; M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARK")]), _vm._v(" 11:25; C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OL")]), _vm._v(". 3:12–13; E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PH")]), _vm._v(". 4:32; L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UKE")]), _vm._v(" 17:5")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6f4b3a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter15.vue
// module id = 108
// module chunks = 0